export const decorationValueMapping = {
  None: 'none',
  'Right Top': 'topRight',
  'Left Top': 'topLeft',
  'Left Bottom': 'bottomLeft',
  'Right Bottom': 'bottomRight',
};

export const mapDecorationValues = key => decorationValueMapping[key];
